import { render, staticRenderFns } from "./message-detail.vue?vue&type=template&id=33ce602c&scoped=true"
import script from "./message-detail.vue?vue&type=script&lang=js"
export * from "./message-detail.vue?vue&type=script&lang=js"
import style0 from "./message-detail.vue?vue&type=style&index=0&id=33ce602c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce602c",
  null
  
)

export default component.exports